import React from "react";
import SegmentedToggle from "./segmented-toggle";

const MODE_OPTIONS = [
  { value: "off", label: "Off" },
  { value: "auto", label: "Auto" },
  { value: "on", label: "On" },
];

/**
 * Off / Auto / On selector for warm-up and cool-down (issue #70).
 *
 * Auto lets the AI size the segment and skip it below the user's threshold; On
 * always adds one at a fixed duration; Off never adds one.
 */
const SegmentModeToggle = ({ id, value, onChange, className = "" }) => (
  <SegmentedToggle
    id={id}
    value={value}
    onChange={onChange}
    options={MODE_OPTIONS}
    className={`shrink-0 ${className}`}
    itemClassName="w-14"
  />
);

export default SegmentModeToggle;
